import React, { useState, useRef, useEffect } from "react";
import {
    InboxOutlined,
    SyncOutlined,
    OpenAIOutlined,
    UserOutlined,
} from "@ant-design/icons";
import "../../Components/componentsStyle.css";

import ThumbsUp from '../../Images/FeedbackThum/thumbsUp.svg'
import ThumbsDown from '../../Images/FeedbackThum/thumbsDown.svg'
import ThumbsUpFilled from '../../Images/FeedbackThum/thumbsUpFilled.svg'
import ThumbsDownFilled from '../../Images/FeedbackThum/thumbsDownFilled.svg'
import apiService from "../../Services/apiServices";


const MessageAF1 = (props) => {
    const { item, msg, fadeInProps, updateMessage, showMaximumChat, setIsFeedbackPop, index, messages, token, sessionId, checkThumsDownFeedback, showRegenerate, array } = props;
   
  

    
   
   
    // State to manage like/dislike status and whether the buttons are disabled
    const [isLiked, setIsLiked] = useState(false);
    const [isDisliked, setIsDisliked] = useState(false);
    const [isFeedbackButtonDisabled, setIsFeedbackButtonDisabled] = useState(false);

    function getLLMResponse(array, command = "A3") {
        let foundItem = array?.find(item => item?.uiCommand === command);
    
        if (foundItem) {
            try {
                foundItem.text = JSON.parse(foundItem.text);
            } catch (e) {
                // Keep text as it is if parsing fails
            }
        }
    
        return foundItem?.text;
    }

    const llmResponse = getLLMResponse(array);
   

    const handleLike = () => {
        setIsLiked(true);
        setIsDisliked(false);
        props?.setShowR1FeedbackPop((prevState) => ({ ...prevState, isActive: false }));
        props?.addMessagesFeedback('Thumbs Up', props?.item?.code, null, null, null, { "feedbackThumbs": "thumbsUp" })
        let n = document.getElementsByClassName("thums-button");

        for (let i = 0; i < n.length; i++) {
            n[i].disabled = true;
            n[i].style.cursor = "not-allowed";
            // n[i].style.opacity = 0.5;
            n[i].style.pointerEvents = "none";
        }
        // if (!isFeedbackButtonDisabled) {
        //     setIsLiked(true);
        //     setIsDisliked(false);
        //     setIsFeedbackButtonDisabled(true); // Disable buttons after clicking
        //     apiService.feedbackApi({ feedbackThumbs: 'thumsUp'   ,sessionId:sessionId})
        // }
    };

    const handleDislike = () => {
        if (!isFeedbackButtonDisabled) {
            setIsFeedbackPop(true)
            setIsDisliked(true);
            setIsLiked(false);


        }
    };

    // useEffect(() => {
    //     if (index !== messages?.length - 1) {
    //         setIsFeedbackButtonDisabled(true)
    //     }
    // })

    // useEffect(() => {

    //     checkThumsDownFeedback?.includes(index) && setIsFeedbackButtonDisabled(true)

    // }, [checkThumsDownFeedback])




    return (
        <div
            className="server-response-footer"
            style={{justifyContent : array?.some(item => item.uiCommand === "A3") ?  'space-between' : 'end'}}
        >
           {array?.some(item => item.uiCommand === "A3") && (<div
                style={{
                    display: "flex",
                    cursor: (item?.thumbsUp || item?.thumbsDown || showRegenerate  ) ? 'default' : 'pointer',
                    marginTop: '12px',
                    ...fadeInProps,
                }}
            >
                {
                    <>
                        <SyncOutlined className="regenerate"   style={{ marginRight: 4 ,color: item?.thumbsUp || item?.thumbsDown || showRegenerate   ? 'gray' :'#d02f92',}} />
                        <button 
                        onClick={() => {
                            props?.setShowR1FeedbackPop((prevState) => ({ ...prevState, isActive: false }));
                            updateMessage(llmResponse)
                        }}
                        style={{
                            color: item?.thumbsUp || item?.thumbsDown || showRegenerate  ? 'gray' :'#d02f92',
                            cursor: item?.thumbsUp || item?.thumbsDown || showRegenerate  ? 'not-allowed' : 'pointer',
                            pointerEvents: item?.thumbsUp || item?.thumbsDown || showRegenerate   ? 'none' : 'auto',
                            border : 'none',
                          }}
                          disabled ={item?.thumbsUp || item?.thumbsDown || showRegenerate }
                          className="regenerate"
                        >Regenerate</button>
                    </>
                }
            </div>)}
            <div className="regenerate" style={{ display: 'flex' }}>
                {/* {showMaximumChat && msg?.llm_response?.Doc_version && (
                    <div className="version">
                       {msg?.llm_response?.Doc_version && <>Version</>} {msg?.llm_response?.Doc_version} ({msg?.llm_response?.Doc_updated_on})
                    </div>
                )} */}
                <div style={{ marginTop: '12px' }}>
                    <img
                        style={{ width: '24px', height: '28px', cursor: 'pointer' }}
                        src={item?.thumbsUp ? ThumbsUpFilled : ThumbsUp}
                        alt={isLiked ? "ThumbsUpFilled" : "ThumbsUp"}
                        className='thums-button'
                        // onClick={() => handleLike()}
                        onClick={() => {
                            setTimeout(() => {
                                props?.scrollToBottom()
                            }, 100);
                           
                            props?.setShowR1FeedbackPop((prevState) => ({ ...prevState, isActive: true  , option : 'up' }));
                        }}
                    />
                    <img
                        style={{ width: '24px', height: '28px', cursor: 'pointer' }}
                        src={item?.thumbsDown ? ThumbsDownFilled : ThumbsDown}
                        alt={isDisliked ? "ThumbsDownFilled" : "ThumbsDown"}
                        className='thums-button'
                        onClick={() => {
                            setTimeout(() => {
                                props?.scrollToBottom()
                            }, 100);
                           
                            props?.setShowR1FeedbackPop((prevState) => ({ ...prevState, isActive: true  , option : 'down'}));
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default MessageAF1
